import {ActionTypes as ConfigActionTypes} from 'store/config/configConstants';



const initialState = {
    config: undefined,
    error: false
};
const reducer = (state = initialState, action:any) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case ConfigActionTypes.FETCH_CONFIG_FULFILLED:
            newState.config = action.payload.data;
            return newState;
        case ConfigActionTypes.FETCH_CONFIG_REJECTED:
            newState.error = true;
            return newState;

        default:
            return newState;
    }
};
export default reducer;